// Updated TopPage.js
import React, { useEffect, useState } from "react";
import Header from "../components/global/Header";
import Footer from "../components/global/Footer";
import TopPage from "../components/top-pages/TopPage";
import CopilotLayout from "../components/layout/CopilotLayout";
import CopilotActions from "../components/layout/CopilotActions";
import { useAiSettings } from "../contexts/AiSettingsContext";
import useLocalStorage from "../hooks/useLocalStorage";
import { createUpdateBusinessSheetData } from "../utils/businessSheetUtils";

const TopPageWithCopilot = ({
  businessSheetData,
  updateBusinessSheetData,
}) => {
  // Issue #72: AI が有効なときだけ Copilot のフックを呼ぶ
  const { aiEnabled } = useAiSettings();

  return (
    <>
      {aiEnabled && (
        <CopilotActions
          businessSheetData={businessSheetData}
          updateBusinessSheetData={updateBusinessSheetData}
        />
      )}
      <TopPage businessSheetData={businessSheetData} />
    </>
  );
};

const TopPageContainer = () => {
  const [businessSheetData, setBusinessSheetData] = useState(null);
  const { getValue, setValue } = useLocalStorage();

  useEffect(() => {
    console.log("get sheet for top page");
    setBusinessSheetData(getValue("businessSheetData"));
  }, [getValue]);

  const updateBusinessSheetData = createUpdateBusinessSheetData(
    setBusinessSheetData,
    setValue
  );

  return (
    <>
      <Header />
      <CopilotLayout
        businessSheetData={businessSheetData || {}}
        updateBusinessSheetData={updateBusinessSheetData}
        >
        {/* Use conditional rendering with a fallback */}
        <TopPageWithCopilot
          businessSheetData={businessSheetData || {}}
          updateBusinessSheetData={updateBusinessSheetData}
        />
      </CopilotLayout>
      <Footer />
    </>
  );
};

export default TopPageContainer;